/** 手机触控：独立操作按钮使用至少44px点击区域；桌面保持原紧凑布局，业务权限、提交与跳转逻辑不变。 */
import React, { useState } from "react";
import { Calculator } from "lucide-react";
import { errMsg, inp } from "./refUtils";

/* 规则卡「试算」：示例合同额 → 按当前规则（或编辑中的未保存值）即时算佣金，不落库 */
export function RuleTrial({ api, zh, rid, draft }) {
  const [total, setTotal] = useState("");
  const [excl, setExcl] = useState("");
  const [res, setRes] = useState(null);
  const [err, setErr] = useState("");
  const run = async () => {
    setErr(""); setRes(null);
    try {
      const body = { contractTotal: total, excludedAmount: excl || 0 };
      if (draft) Object.assign(body, { mode: draft.mode, fixedAmount: draft.fixedAmount, pct: draft.pct, cap: draft.cap });
      const { data } = await api.post(`/referral/rules/${rid}/preview`, body); setRes(data);
    } catch (e) { setErr(errMsg(e)); }
  };
  return (
    <div className="mt-2 rounded-lg bg-slate-50 border border-slate-200 p-2" data-testid={`rule-${rid}-trial`}>
      <div className="flex items-end gap-2 flex-wrap">
        <label className="block"><span className="text-[10.5px] text-slate-500">{zh ? "示例合同额 $" : "Sample contract $"}</span><input type="number" min="0" className={`${inp} w-32 py-1`} data-testid={`rule-${rid}-trial-input`} value={total} onChange={(e) => setTotal(e.target.value)} placeholder="300000" /></label>
        <label className="block"><span className="text-[10.5px] text-slate-500">{zh ? "排除项 $（可空）" : "Exclusions $"}</span><input type="number" min="0" className={`${inp} w-28 py-1`} data-testid={`rule-${rid}-trial-excl`} value={excl} onChange={(e) => setExcl(e.target.value)} /></label>
        <button type="button" className="min-h-11 min-w-11 md:min-h-0 md:min-w-0 text-xs border border-indigo-300 text-indigo-700 rounded-lg px-2.5 py-1.5 inline-flex items-center gap-1 disabled:opacity-50" disabled={!total} data-testid={`rule-${rid}-trial-run`} onClick={run}><Calculator className="h-3.5 w-3.5" />{zh ? "试算" : "Calculate"}{draft ? (zh ? "（按编辑中的值）" : " (unsaved values)") : ""}</button>
      </div>
      {err && <p className="text-[11px] text-red-600 mt-1" data-testid={`rule-${rid}-trial-error`}>{err}</p>}
      {res && (
        <p className="text-[11px] mt-1.5" data-testid={`rule-${rid}-trial-result`} data-state={res.state}>
          <span className={`font-semibold ${res.amount === null ? "text-amber-700" : "text-emerald-700"}`}>{res.amount === null ? (zh ? "待配置 · 不产生金额" : "TBD · no amount") : `$${Number(res.amount).toLocaleString(undefined, { minimumFractionDigits: 2 })}`}</span>
          <span className="text-slate-500"> · {res.label} · {res.formula}{res.saved ? "" : (zh ? " · 未保存的试算值" : " · unsaved")}</span>
        </p>
      )}
    </div>
  );
}
